/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useSelector } from "react-redux";

import { useViewId } from "../../utils/useViewId";
import { useFormNavigation } from "../../components/FormNavigation/FormNavigationProvider";
import { useLayoutParams } from "../FormLayout";
import { OtpChannel, formStepper } from "../../constants";
import { FormConfirm } from "./components/FormConfirm";
import {
  getApplicantInfo,
  getIsEmailChanged,
  getIsMultiPartnerJourney,
  getIsSignatoryPrimaryEmailChanged
} from "../../store/selectors/appConfig";
import {
  checkIsSelectedStakeholderSignatory,
  getSelectedStakeholder
} from "../../store/selectors/stakeholders";
import { getsIsContactAndSignatoryDetailsChanged } from "../../store/selectors/sendProspectToAPI";
import { FormConfirmCompanyAndSignatory } from "./components/FormConfirmCompanyAndSignatory";

const getEmail = ({
  isMultiPartnerJourney,
  selectedPartner,
  isCompanyEmailChanged,
  isSignatoryPrimaryEmailChanged,
  editedEmailId,
  applicantInfo,
  isSignatory
}) => {
  if (isMultiPartnerJourney && selectedPartner && Object.keys(selectedPartner).length > 0) {
    if (isCompanyEmailChanged && isSignatory) {
      return editedEmailId;
    } else if (isSignatoryPrimaryEmailChanged) {
      return (
        selectedPartner.contactDetails.editedPrimaryEmailId ||
        selectedPartner.contactDetails.primaryEmail
      );
    } else {
      return selectedPartner.contactDetails.primaryEmail;
    }
  } else {
    if (isCompanyEmailChanged) {
      return editedEmailId;
    } else {
      return applicantInfo.email;
    }
  }
};

export default function FormEmailConfirmPage() {
  useFormNavigation([false, false, formStepper]);
  useLayoutParams(false);
  useViewId();
  const applicantInfo = useSelector(getApplicantInfo);
  const isCompanyEmailChanged = useSelector(getIsEmailChanged);
  const isSignatoryPrimaryEmailChanged = useSelector(getIsSignatoryPrimaryEmailChanged);
  const isMultiPartnerJourney = useSelector(getIsMultiPartnerJourney);
  const selectedPartner = useSelector(getSelectedStakeholder);
  const isContactAndSignatoryDetailsChanged = useSelector(getsIsContactAndSignatoryDetailsChanged);
  const isSignatory = useSelector(checkIsSelectedStakeholderSignatory);
  const editedEmailId = selectedPartner?.editedEmailId;

  const email = getEmail({
    isMultiPartnerJourney,
    selectedPartner,
    isCompanyEmailChanged,
    isSignatoryPrimaryEmailChanged,
    editedEmailId,
    applicantInfo,
    isSignatory
  });

  const emailStyle = {
    color: "#5E080B",
    fontWeight: 500
  };

  const getTitle = () => {
    if (isMultiPartnerJourney) {
      return isCompanyEmailChanged ? "company" : "your";
    }
    return "your";
  };

  const title = `Let's verify ${getTitle()} email address`;

  const infoSpan = (
    <span>
      Enter the 6-digits One Time Password (OTP) we sent to <span style={emailStyle}>{email}</span>.
      If you don't see the email in your inbox, try checking your spam or junk folder.
    </span>
  );

  const changeText = "Change email";

  return !isContactAndSignatoryDetailsChanged ? (
    <FormConfirm otpType={OtpChannel.Email} title={title} info={infoSpan} changeText={changeText} />
  ) : (
    <FormConfirmCompanyAndSignatory
      otpType={OtpChannel.Email}
      title={title}
      info={infoSpan}
      changeText={changeText}
    />
  );
}
